import {TwoColumnCell} from '@atoms';
import {ModalCell, ModalCellItemIcon} from '@molecules';
import {FlexCol, Span, Subtitle} from '@quarks';
import {pxToRem} from '@utils';
import {ErrorBoundary} from 'react-error-boundary';
import {MapSelectorCard_timeslots} from '../../MapSelectorCard/MapSelectorCard_timeslots';
import {Member} from './useReservationDetails';
import {IconNames} from 'mapiq-atoms';

export const FullMapView = ({
  icon,
  title,
  subtitle,
  members,
}: {
  icon: IconNames;
  title: string;
  subtitle?: string;
  members: Array<Member>;
}) => {
  return (
    <FlexCol
      gap={16}
      height={'100%'}>
      <ErrorBoundary
        fallbackRender={({error}) => {
          return <div className="text-functional-red">{error?.message ?? 'Failed to render map'}</div>;
        }}>
        <MapSelectorCard_timeslots members={members} />
      </ErrorBoundary>
      <ModalCell>
        <TwoColumnCell
          padding="small"
          alignItems="flex-start"
          separator={false}
          left={<ModalCellItemIcon icon={icon} />}
          right={
            <FlexCol minHeight={pxToRem(48)}>
              <Span fontWeight="bold">{title}</Span>
              <Subtitle>{subtitle}</Subtitle>
            </FlexCol>
          }
        />
      </ModalCell>
    </FlexCol>
  );
};
